

const FileUpload = 'https://emfdevbk.athithishala.com/media/'

export default FileUpload